import {Injectable} from '@angular/core';
import {StorageFactory} from './storage.factory';
import {Configuration} from '../configuration';
import {DateUtilService} from '../utils/date_util.service';

@Injectable()
export class StoreService extends StorageFactory {

  protected cache: any = {};

  constructor(private config: Configuration,
              private dateUtils: DateUtilService) {
    super();
  }

  getTwoFaRequest(): string | null {
    return this.get(this.config.HEADER_FIELDS.twoFaRequestCode);
  }

  getTwoFaTimeExpire(): Date | null {
    if (this.get(this.config.HEADER_FIELDS.twoFaTimeExpire) != null &&
      this.get(this.config.HEADER_FIELDS.twoFaTimeExpire) !== 'null') {
      const expiredTime: Date = new Date();
      expiredTime.setTime(Date.parse(this.get(this.config.HEADER_FIELDS.twoFaTimeExpire) as string));
      return expiredTime;
    }
    return null;
  }

  isValidTwoFaRequest(): boolean {
    return this.getTwoFaRequest() != null && this.getTwoFaRequest() !== 'null' &&
      this.getTwoFaTimeExpire() != null && !this.isTwoFaTimeExpired();
  }

  isTwoFaTimeExpired(): boolean {
    return this.dateUtils.diffDateInSeconds(this.dateUtils.addMinutes(this.getTwoFaTimeExpire(), 10), new Date()) < 0;
  }

  setTwoFaRequest(twoFaRequestCode): void {
    this.set(this.config.HEADER_FIELDS.twoFaRequestCode, twoFaRequestCode);
  }

  setTwoFaTimeExpire(date): void {
    this.set(this.config.HEADER_FIELDS.twoFaTimeExpire, date);
  }

  deleteTwoFaRequest(): void {
    this.delete(this.config.HEADER_FIELDS.twoFaRequestCode);
    this.delete(this.config.HEADER_FIELDS.twoFaTimeExpire);
  }

  getWizard(): boolean {
    return this.getFlag(this.config.IS_WIZARD);
  }

  setWizard(isWizard: boolean): void {
    this.setFlag(this.config.IS_WIZARD, isWizard);
  }

  getLastPage(): any {
    return this.getObject(this.config.LAST_PAGE);
  }

  setLastPage(lastPage: any): void {
    this.setObject(this.config.LAST_PAGE, lastPage);
  }

  deleteLastPage(): void {
    this.delete(this.config.LAST_PAGE);
  }

  getUsername(): string | null {
    return this.get(this.config.LOCK_USER);
  }

  setUsername(username: string): void {
    this.set(this.config.LOCK_USER, username);
  }

  getToSave(): boolean {
    return this.getFlag(this.config.TO_SAVE);
  }

  setToSave(toSave: boolean): void {
    this.setFlag(this.config.TO_SAVE, toSave);
  }

  deleteToSave(): void {
    this.delete(this.config.TO_SAVE);
  }

  deleteAll(): void {
    this.clear();
  }

  deleteAllOnLogin(): void {
    this.clear();
  }

}
